<template>
  <div id="user">
    <div id="tab-bar">
      <ul class="tab-bom">
        <li style="padding-left:57px" @click="routerFuc('/home')"><img src="https://img.deepbaytech.com/fn/logo.png" style="height: 34px;"></li>
      </ul>
    </div>
    <div class="container">
      <div class="main-in">
        <p class="title">密码找回</p>
        <template v-if="type===0">
          <div class="steps">
            <el-steps :active="1" finish-status="success" process-status="wait" :align-center="true">
              <el-step title="账号验证" status="process"></el-step>
              <el-step title="密码找回"></el-step>
              <el-step title="完成"></el-step>
            </el-steps>
          </div>
          <div class="input-tel">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item prop="tel">
                <el-input class="tel" v-model.trim="ruleForm.tel" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <div style="display: flex;justify-content:center;align-items: center;">
                  <el-input class="code" v-model.trim="ruleForm.code" placeholder="验证码">
                  </el-input>
                  <template v-if="show">
                    <a class="tab-programme-a" href="javascript:;" @click="send">发送验证码</a>
                  </template>
                  <template v-else>
                    <a class="tab-programme-c" href="javascript:;" @click="resend">发送验证码</a>
                  </template>
                  <a v-if="show==false" class="tab-programme-d" href="javascript:; ">{{time===0?'发送验证码':`${time}s重新发送`}}</a>
                </div>
              </el-form-item>
            </el-form>
            <a class="tab-programme-b" href="javascript:;" @click="next">下一步</a>
          </div>
        </template>
        <template v-else-if='type===1'>
          <div class="steps">
            <el-steps :active="2" finish-status="success" process-status="wait" :align-center="true">
              <el-step title="账号验证" class="verification"></el-step>
              <el-step title="密码找回" status="process"></el-step>
              <el-step title="完成"></el-step>
            </el-steps>
            <div style="width: 390px;margin: auto;">
              <div style="margin-top: 40px;margin-bottom: 32px;">
                <span style="margin-right:20px">用户名：</span>
                <span>深湾科技</span>
              </div>
              <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="82px" label-position="left">
                <el-form-item label="新密码：" prop="newPassword">
                  <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入">
                  </el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="conPassword">
                  <el-input type="password" v-model="passwordForm.conPassword" placeholder="请输入">
                  </el-input>
                </el-form-item>
              </el-form>
              <a style="margin-left:82px" class="tab-programme-b" href="javascript:;" @click="nextOne">下一步</a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="steps">
            <el-steps :active="3" finish-status="success" process-status="wait" :align-center="true">
              <el-step title="账号验证" class="verification"></el-step>
              <el-step title="密码找回" class="verification"></el-step>
              <el-step title="完成" status="process"></el-step>
            </el-steps>
          </div>
          <div style="text-align:center;margin-top:40px">
            <img style="wdith:72px;height:72px;" src="https://img.deepbaytech.com/images2021/complete.png" alt="">
            <p style="margin-top:24px;font-size: 24px;font-weight: 500;color: rgba(0, 0, 0, 0.85);">
              操作成功</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    var validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.passwordForm.conPassword !== '') {
          this.$refs.passwordForm.validateField('conPassword')
        }
        callback()
      }
    }
    var validateConPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      type: 0,
      show: true,
      time: 5,
      ruleForm: {
        tel: '13211111111',
        code: '1',
      },
      passwordForm: {
        newPassword: '',
        conPassword: ''
      },
      rules: {
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      passwordRules: {
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        conPassword: [
          { validator: validateConPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    routerFuc (path) {
      this.$router.push(path)
    },
    send () {
      const mobile = (value) => {
        if (!value) return '请输入手机号'
        if (!/^1[3-9]\d{9}$/.test(value)) return '手机号格式错误'
        return true
      }
      if (mobile(this.ruleForm.tel) !== true) {
        this.$message({
          showClose: true,
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      this.show = false
      let timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          clearInterval(timer)
          this.show = true
        }
      }, 1000)
      this.time = 5
    },
    resend () {
      if (this.time !== 0) {
        return
      }
    },
    next () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.type = 1
        }
      })
    },
    nextOne () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.type = 2
        }
      })
    }
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.tab-bom {
  width: 100%;
  height: 64px;
  padding: 0;
  display: flex;
  justify-content: start;
  align-items: center;
}
.tab-bom > li {
  list-style: none;
  cursor: pointer;
}
.container {
  background-color: #f5f5f5;
  padding: 24px;
  height: 900px;
}
.main-in {
  background-color: #fff;
  padding: 24px 24px 233px 24px;
}
.title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 40px;
  /*margin-left: 225px;*/
}
.key {
  display: inline-block;
  width: 122px;
  height: 22px;
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
}
.main-item {
  margin-bottom: 34px;
}
::v-deep .el-form-item__label {
  color: #000;
}
::v-deep .tel .el-input__inner {
  width: 320px;
  height: 32px;
  border-radius: 0%;
  margin: 40px auto 0 auto;
}

::v-deep .code .el-input__inner {
  width: 206px;
  height: 32px;
  border-radius: 0%;
}
.steps {
  width: 864px;
  margin: auto;
}
::v-deep .el-step {
  left: -8px;
}
::v-deep .el-step__head.is-process .el-step__icon.is-text {
  position: relative;
  background: #77ba00;
  color: #fff;
  border: none;
  font-size: 16px;
  width: 32px;
  height: 32px;
}
::v-deep .el-step__icon.is-text {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-step__title {
  position: absolute;
  left: 165px;
  top: -4px;
}
::v-deep .el-step.is-center .el-step__line {
  position: absolute;
  left: 240px;
  top: 14px;
  width: 160px;
  height: 1px;
  background: #e9e9e9;
}
::v-deep .el-step__description.is-process {
  padding: 0 !important;
  margin: 0 !important;
}
.input-tel {
  width: 320px;
  margin: auto;
}
::v-deep .el-button {
  width: 106px;
  height: 32px;
  border-radius: 0;
}
.tab-programme-a {
  display: inline-block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  border: 1px solid #d9d9d9;
  margin-left: 8px;
}
.tab-programme-b {
  display: inline-block;
  width: 74px;
  height: 32px;
  background: #77ba00;
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
}
.tab-programme-c {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  background-color: #77ba00;
  font-size: 14px;
  color: #fff;
  border: 1px solid #d9d9d9;
  margin-left: 8px;
  text-decoration: none;
  text-align: center;
}
.tab-programme-d {
  position: absolute;
  top: 4px;
  left: 350px;
  display: inline-block;
  width: 106px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  border: 1px solid #d9d9d9;
  margin-left: 8px;
  text-decoration: none;
  text-align: center;
}
::v-deep .verification .el-step__icon.is-text {
  border: 1px solid #77ba00;
}
::v-deep .verification .el-step__title.is-success {
  color: #c0c4cc;
  font-size: 16px;
}
.newPwd.el-input,
.conPwd.el-input {
  width: 0;
}
::v-deep .el-input__inner {
  width: 320px;
  height: 32px;
  border-radius: 0%;
}
</style>
